import { DialogContent, DialogTitle } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import PopUp from "../popUpInterface";
import { styles } from "./styles";
import Loading from "../loading";
import Album from "../service/ownerSpa/serviceAlbum/album";
class SelectUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  open = () => {
    this.PopUp.handleDialogOpen();
  };
  close = () => {
    this.PopUp.handleDialogClose();
  };
  render() {
    const { classes, t, selectImage } = this.props;
    return (
      <Fragment>
        <PopUp
          onRef={(dialog) => (this.PopUp = dialog)}
          openDialogs={this.state.openDialogs}
          aria-labelledby="customized-dialog-title"
          flagOpen={false}
          handleDialogClose={this.close}
        >
          <Loading onRef={(id) => (this.loading = id)} />
          <DialogTitle
            id="scroll-dialog-title"
            disableTypography
            style={{ padding: 0 }}
          >
            <Typography variant="h2" className={classes.title}>
              {t("chose_image_from_album")}
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.DialogContent}>
            <Album dialogView={true} getFileUrl={(url) => selectImage(url)} />
          </DialogContent>
        </PopUp>
      </Fragment>
    );
  }
}
const mapState = (state) => ({});
const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SelectUpload)
  )
);
